import { Component, OnInit } from '@angular/core';
import { BaseModalComponent } from '../../base-modal.component';
import { ModalService } from '../../../../services/modal/modal.service';

import { AdvisorSelectionService } from '../../../../../../coverpath-agent/public/js/services/advisor-selection/advisor-selection.service';

@Component({
  selector: 'loading-modal',
  moduleId: module.id,
  templateUrl: './loading.component.html',
})
export class LoadingModalComponent extends BaseModalComponent implements OnInit {
  data;
  userResponse: any = {};
  confirm() {}
  cancel() {}

  public title: string = '';
  public body: string = '';
  public loadingColor: string = '';

  constructor(protected modalService: ModalService, private readonly advisorSelectionService: AdvisorSelectionService) {
    super(modalService);
  }

  ngOnInit() {
    const modalData = this.data.modalData;
    this.title = modalData && modalData.title ? modalData.title : 'Loading Application';
    this.body = modalData && modalData.body ? modalData.body : '';
    this.loadingColor = modalData && modalData.loadingColor ? modalData.loadingColor : 'blue';
  }
}
